import Spinner from "@/components/Spinner"
import { useSelfQuery } from "@/data/queries"
import { ROUTES } from "@/routes"
import { Navigate } from "react-router"

type PostLoginRedirectProps = {
  redirect: string | null
}

const PostLoginRedirect = ({ redirect }: PostLoginRedirectProps) => {
  // Always call hooks unconditionally — redirect check happens after.
  const { data: self, isPending, isError } = useSelfQuery()

  // Honor explicit redirect first (deep-link preserved by Auth).
  if (redirect) {
    return <Navigate to={redirect} replace />
  }

  if (isPending) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="h-10 w-10" />
      </div>
    )
  }

  if (isError || !self) {
    // Self failed despite a valid token — bail to sign-in.
    return <Navigate to={ROUTES.SIGN_IN} replace />
  }

  if (!self.patientAppState.profileFormFilled) {
    return <Navigate to={ROUTES.ONBOARDING} replace />
  }
  if (!self.patientAppState.bloodGlucoseDeviceSetupCompleted) {
    return <Navigate to={ROUTES.BLOOD_GLUCOSE_DEVICE_SETUP} replace />
  }
  return <Navigate to={ROUTES.DASHBOARD} replace />
}

export default PostLoginRedirect
